import { render, staticRenderFns } from "./myhead.vue?vue&type=template&id=379d8c77&"
import script from "./myhead.vue?vue&type=script&lang=js&"
export * from "./myhead.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports